// @ts-nocheck
import { getAccountsDataView } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import translate from "@insite/client-framework/Translate";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import UserSetupPageTypeLink from "@insite/content-library/Components/UserSetupPageTypeLink";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCell } from "@insite/mobius/index";
import Typography from "@insite/mobius/Typography";
import useIsMobile from "@store/Framework/Common/Hooks/useIsMobile";
import BuyingListTableHead from "@store/Library/Components/BuyingList/BuyingListTableHead";
import { StyledRow } from "@store/Library/Components/BuyingList/ManageProductsModal";
import { StyledCol } from "@store/Library/Components/Common/StyledCol";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

const mobileColumns = [60, 40];
const desktopColumns = [5, 40, 40, 15];
const tabletColumns = [5, 35, 35, 25];
interface ManageUsersModalTableProps {
    userListHeaders: (string | JSX.Element)[];
    userAccountsDataView: ReturnType<typeof getAccountsDataView>;
    selectedUsers: string[];
    setSelectedUsers: (selectedUsers: string[]) => void;
    handleAssign: (userId: string) => void;
    loading: boolean;
    assignedUsers: string[];
}

interface ManageUsersModalTableStyles {
    linkDataTableCell?: DataTableCellProps;
    fullwidthDataTableCell?: DataTableCellProps;
    assignButton?: ButtonProps;
    dataTable?: DataTableProps;
}

export const styles: ManageUsersModalTableStyles = {
    dataTable: {
        css: css`
            border-collapse: separate;
            table-layout: fixed;
            border-spacing: 0 ${pxToRem(1)};
        `,
    },
    assignButton: {
        css: css`
            min-width: 8rem;
            border-radius: 0.5rem;
        `,
    },
    linkDataTableCell: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 14rem;
                display: block;
            `,
        },
    },
    fullwidthDataTableCell: {
        css: css`
            width: 100%;
        `,
    },
};
const getColumnsToUse = (isMobile: boolean | null, isTablet: boolean | null) => {
    if (isTablet) {
        return tabletColumns;
    }
    if (isMobile) {
        return mobileColumns;
    }
    return desktopColumns;
};
const ManageUsersModalTable: React.FC<ManageUsersModalTableProps> = ({
    handleAssign,
    loading,
    selectedUsers,
    setSelectedUsers,
    userAccountsDataView,
    userListHeaders,
    assignedUsers,
}) => {
    const isMobile = useIsMobile();
    const isTablet = useIsMobile({ width: 1025 });
    const columnsToUse = getColumnsToUse(isMobile, isTablet);
    return (
        <DataTable {...styles.dataTable}>
            <colgroup>
                {columnsToUse.map((width, index) => (
                    <StyledCol key={width + index.toString()} width={width} />
                ))}
            </colgroup>

            <BuyingListTableHead
                buyingListHeaders={isMobile ? [translate("Name"), translate("Action")] : userListHeaders}
            />

            {userAccountsDataView?.value?.length ? (
                userAccountsDataView?.value?.map(user => {
                    const isSelected = selectedUsers.includes(user.id);
                    const isAssigned = assignedUsers.includes(user.id);
                    return (
                        <StyledRow isHighlighted={isAssigned && !loading} key={user.id}>
                            {!isMobile && (
                                <DataTableCell>
                                    <Checkbox
                                        disabled={loading}
                                        color={loading ? "transparent" : undefined}
                                        checked={isSelected}
                                        onChange={() => {
                                            if (isSelected) {
                                                setSelectedUsers(selectedUsers.filter(id => id !== user.id));
                                            } else {
                                                setSelectedUsers([...selectedUsers, user.id]);
                                            }
                                        }}
                                    />
                                </DataTableCell>
                            )}
                            <DataTableCell
                                typographyProps={{
                                    ellipsis: true,
                                    css: css`
                                        width: 14rem;
                                        display: block;
                                    `,
                                }}
                            >
                                <Typography // keeping inline because its dynamic
                                    css={
                                        loading
                                            ? css`
                                                  width: 95%;
                                                  display: block;
                                                  height: 50px;
                                              `
                                            : undefined
                                    }
                                >
                                    <UserSetupPageTypeLink
                                        title={`${user.firstName} ${user.lastName}`}
                                        userId={user.id}
                                    />
                                </Typography>
                            </DataTableCell>
                            {!isMobile && (
                                <DataTableCell {...styles.linkDataTableCell}>
                                    <Typography>{`${user.email}`}</Typography>
                                </DataTableCell>
                            )}
                            <DataTableCell {...styles.fullwidthDataTableCell}>
                                {isAssigned ? (
                                    <Button
                                        onClick={() => handleAssign(user.id)}
                                        variant="tertiary"
                                        {...styles.assignButton}
                                    >
                                        {translate("Unassign")}
                                    </Button>
                                ) : (
                                    <Button onClick={() => handleAssign(user.id)} {...styles.assignButton}>
                                        {translate("Assign")}
                                    </Button>
                                )}
                            </DataTableCell>
                        </StyledRow>
                    );
                })
            ) : (
                <>
                    <DataTableCell />
                    <DataTableCell />
                    <DataTableCell />
                    <DataTableCell />
                </>
            )}
        </DataTable>
    );
};
export default ManageUsersModalTable;
